"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactor = void 0;
var _react = _interopRequireDefault(require("react"));
var _Totp = require("./Totp");
var _EmailSwitch = require("./EmailSwitch");
var _Withdraw = require("./Withdraw");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TwoFactor = function TwoFactor() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react.default.createElement(_Totp.Totp, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react.default.createElement(_EmailSwitch.EmailSwitch, null)), /*#__PURE__*/_react.default.createElement(_Withdraw.WithdrawSwitch, null));
};
exports.TwoFactor = TwoFactor;